import styled from 'styled-components';
import { color, screen, spacing } from 'theme';

export const Root = styled.div`
  background: ${color('sun_100')};
  padding: ${spacing('xl3')} 0;
`;

export const Intro = styled.div`
  text-align: center;
  max-width: 40rem;
  margin: auto;

  h3 {
    margin-bottom: 0;
  }

  p {
    font-size: 1.25rem;
    margin-bottom: 2rem;
  }
`;

export const CTA = styled.div`
  text-align: center;
`;

export const Features = styled.div``;

export const Feature = styled.div`
  background: ${color('indigo_700')};
  color: #fff;
  padding: 4rem;
  border-radius: 10px;
  margin-bottom: 1.5rem;

  h4 {
  }

  p {
    font-size: 1.25rem;
  }

  .items {
    flex: 1 0 45%;
    width: 45%;

    ul,
    li {
      margin: 0;
      padding: 0;

      img {
        height: 64px;
        width: 64px;
      }
    }

    ul {
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 1.25rem;
      row-gap: 1.25rem;

      @media (max-width: ${screen('lg')}) {
        display: flex;
        flex-direction: column;
        gap: 1.25rem;
      }
    }

    li {
      display: flex;
      align-items: center;
      gap: 1rem;
    }
  }
`;
